export default "__VITE_ASSET__937551b6__"